import React, { useContext, useState } from 'react'
import { BsAlignBottom, BsAlignCenter, BsAlignEnd, BsAlignMiddle, BsAlignStart, BsAlignTop, BsBorderAll } from 'react-icons/bs'
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider';

const Position = () => {

  const { textEditorOptions, setTextEditorOptions, editor } = useContext(EditorContext);
  const [openPosition, setOpenPosition] = useState(false)

  const handleChange = (pos) => {
    let positions = editor.canvasPosition()
    const { left, right, bottom, top, centerX, centerY } = positions

    if (pos === 'left') {
      setTextEditorOptions({ ...textEditorOptions, left: left })      
    }
    else if(pos === 'right') {
      setTextEditorOptions({ ...textEditorOptions, left: right })
    }
    else if(pos === 'top') {
      setTextEditorOptions({ ...textEditorOptions, top: top })
    }
    else if(pos === 'bottom'){
      setTextEditorOptions({ ...textEditorOptions, top: bottom })
    }
    else if(pos === 'centerX'){
      setTextEditorOptions({ ...textEditorOptions, left: centerX })
    }
    else if(pos === 'centerY'){
      setTextEditorOptions({ ...textEditorOptions, top: centerY })
    }
  }

  return (
    <div className='editor-item position'>
      <div className={`editor-icon ${openPosition ? 'active' : ''}`} onClick={e=> setOpenPosition(!openPosition)} data-toggle="tooltip" data-placement="top" title="Position">
        <BsBorderAll />
      </div>
      <div className={`position-list ${openPosition ? '' : 'd-none'}`}>
        <div className='position-item' onClick={e=>handleChange('top')}>
          <span><BsAlignTop /></span>
        </div>
        <div className='position-item' onClick={e=>handleChange('left')}>
          <span><BsAlignStart /></span>
        </div>
        <div className='position-item' onClick={e=>handleChange('bottom')}>
          <span><BsAlignBottom /></span>
        </div>
        <div className='position-item' onClick={e=>handleChange('right')}>
          <span><BsAlignEnd /></span>
        </div>
        <div className='position-item' onClick={e=>handleChange('centerY')}>
          <span><BsAlignCenter /></span>
        </div>
        
        <div className='position-item' onClick={e=>handleChange('centerX')}>
          <span><BsAlignMiddle /></span>
        </div>
        
        
      </div>
    </div>
  )
}

export default Position